import React from "react";
import OpenText from "../../OpenText";
import ScrollReveal from "../../ui/ScrollReveal";

const Home = () => {
  return (
    <div className="home-page mx-auto w-full max-w-5xl px-4 pb-16 pt-4 sm:px-6 lg:px-8">
      <ScrollReveal className="mb-10 text-center">
        <div className="ui-card relative overflow-hidden border-0 bg-gradient-to-br from-surface via-surface to-canvas px-6 py-10 text-center shadow-glow sm:px-10 sm:py-14">
          <div
            className="pointer-events-none absolute -start-[20%] -top-1/2 h-64 w-64 rounded-full bg-accent/10 blur-3xl"
            aria-hidden
          />
          <div
            className="pointer-events-none absolute -bottom-1/2 -end-[15%] h-72 w-72 rounded-full bg-accent/5 blur-3xl"
            aria-hidden
          />
          <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-muted">
            Hamazon Online
          </p>
          <h1 className="m-0 font-display text-3xl font-semibold leading-tight text-foreground sm:text-4xl">
            ברוכים הבאים להמזון אונליין
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-base text-muted sm:text-lg">
            חווית קנייה נקייה, מהירה ונוחה — עם מבצעים, מעקב הזמנה ושירות שמתאים
            לקצב שלך.
          </p>
        </div>
      </ScrollReveal>

      <ScrollReveal rootMargin="0px 0px -8% 0px">
        <div className="overflow-hidden rounded-card border border-border bg-surface/90 p-0 shadow-card backdrop-blur-sm">
          <OpenText ShowHome={true} />
        </div>
      </ScrollReveal>
    </div>
  );
};

export default Home;
